//@flow
import SingleTeamSelect from './SingleTeamSelect';
import MultiTeamSelect from './MultiTeamSelect';
import popOverFactory from 'common/components/core/popover/popOverFactory';

const SingleTeamSelectWithPopover = popOverFactory({
    withObserverFlag: true,
    Component: SingleTeamSelect
});

const MultiTeamSelectWithPopover = popOverFactory({
    withObserverFlag: true,
    Component: MultiTeamSelect
});

export default SingleTeamSelect;
export {
    SingleTeamSelectWithPopover,
    SingleTeamSelect,
    MultiTeamSelect,
    MultiTeamSelectWithPopover
};
